document.addEventListener("DOMContentLoaded", function () {
  // --- Fare (Cursor) Ayarları ---
  const cursorStyle = document.createElement("style");
  cursorStyle.innerHTML = `
    .xenon-bubble {
      cursor: default !important; 
    }
  `;
  document.head.appendChild(cursorStyle);

  // Production portal gateway; also used when the Liquid configuration is absent.
  const GATEWAY_URL = window.xenonGatewayUrl || "https://api.portal.dumanarge.com";

  const XENON_THINKING_MESSAGES = [
    "Sizin için en iyi cevabı hazırlıyorum...",
    "Hemen kontrol ediyorum...",
    "Bilgiler taranıyor, lütfen bekleyin...",
    "Sistem kayıtlarına bakıyorum...",
    "Ürün detaylarını inceliyorum...",
    "Detayları toparlıyorum...",
    "Sizin için araştırıyorum...",
    "Talebinizi detaylıca inceliyorum...",
    "Çözüm yolları aranıyor...",
    "Veritabanını tarıyorum...",
    "Hemen yanıtlııyorum...",
    "Dosyalara göz atıyorum...",
    "Konuyu analiz ediyorum...",
    "Sorunuzu işliyorum...",
    "Sizin için harika bir cevap hazırlıyorum...",
  ];
  const XENON_THINKING_ROTATE_MS = 2000;
  const XENON_THINKING_FADE_MS = 250;

  let chatSocket = null;
  let activeBubble = null;
  let aiStreamBuffer = "";
  let thinkingTimer = null;
  let thinkingFadeTimer = null;
  let responseTimeoutTimer = null;

  // AI Soru Sorma İzni
  let canAskAi = false;

  // --- 1. OTURUM (SESSION) VE SOCKET LOGLAMA YARDIMCILARI ---
  function getOrCreateSessionId() {
    let sessionId = sessionStorage.getItem("xenon_session_id");
    if (!sessionId) {
      sessionId = "sess_" + Date.now() + "_" + Math.random().toString(36).substring(2, 9);
      sessionStorage.setItem("xenon_session_id", sessionId);
    }
    return sessionId;
  }

  function logButtonClick(step, label) {
    const socket = getSocket();
    const payload = {
      sessionId: getOrCreateSessionId(),
      customer: window.xenonCustomer || { isLoggedIn: false, name: "Misafir", email: "Misafir" },
      step: step,
      label: label,
      pageUrl: window.location.href,
      timestamp: new Date().toISOString()
    };

    if (socket && socket.connected) {
      socket.emit("analytics:log_click", payload);
    } else if (socket) {
      socket.once("connect", () => {
        socket.emit("analytics:log_click", payload);
      });
    }
  }

  function stopThinkingRotation() {
    if (thinkingTimer !== null) {
      clearInterval(thinkingTimer);
      thinkingTimer = null;
    }
    if (thinkingFadeTimer !== null) {
      clearTimeout(thinkingFadeTimer);
      thinkingFadeTimer = null;
    }
    if (responseTimeoutTimer !== null) {
      clearTimeout(responseTimeoutTimer);
      responseTimeoutTimer = null;
    }
  }

  function buildCta(href, label) {
    return `<a class="xenon-cta" href="${href}" target="_blank" rel="noopener noreferrer">${label}<span aria-hidden="true">→</span></a>`;
  }

  function replaceLinksWithButton(text) {
    if (!text) return "";

    // KALIN YAZI (BOLD) İPTALİ: **metin** formatındaki yıldızları silip içindeki düz metni bırakır.
    let parsedText = text.replace(/\*\*(.*?)\*\*/g, '$1');

    let lines = parsedText.split(/<br\s*\/?>|\n/gi);
    let processedLines = [];

    for (let i = 0; i < lines.length; i++) {
      let line = lines[i].trim();
      if (!line) continue;

      let urlMatch = line.match(/(https?:\/\/[^\s<]+)/i);

      if (urlMatch) {
        let cleanUrl = urlMatch[1].replace(/[.,;!?]+$/, '').trim();
        let labelText = line.replace(urlMatch[0], '').trim();

        if (!labelText && i + 1 < lines.length && !lines[i + 1].match(/https?:\/\//i)) {
          labelText = lines[i + 1].trim();
          i++;
        }

        processedLines.push(buildCta(cleanUrl, labelText || "Ürün Linki"));
      } else {
        processedLines.push(line);
      }
    }

    return processedLines.join("<br>");
  }

  function getSocket() {
    if (chatSocket && chatSocket.connected) return chatSocket;

    chatSocket = io(GATEWAY_URL + "/chatbot", {
      transports: ["websocket"],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5,
    });

    chatSocket.on("connect_error", function (err) {
      console.error("Gateway Socket.IO bağlantı hatası:", err.message);
    });

    chatSocket.on("chat_response_chunk", function (payload) {
      if (!activeBubble) return;

      const chunk = payload.chunk || "";

      if (aiStreamBuffer === "") {
        stopThinkingRotation();
        activeBubble.innerHTML = "";
      }

      aiStreamBuffer += chunk;
      
      // KAYNAKÇA İPTALİ: [#1], [1], [doc_1] vb. referans etiketlerini boşluklarıyla birlikte temizler
      let cleanBuffer = aiStreamBuffer
        .replace(/\s*\[\s*(?:#\s*)?(?:doc_)?\d+\s*\]/gi, "") // Tamamlanmış etiketleri siler
        .replace(/\s*\[[^\]]*$/, ""); // Akış esnasında henüz kapanmamış " [" parçasını ekranda gizler
        
      let formattedText = cleanBuffer.replace(/\n/g, "<br>");

      activeBubble.innerHTML = replaceLinksWithButton(formattedText);
      
      if (messagesContainer) {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
        saveState();
      }
    });

    chatSocket.on("chat_response_done", function (payload) {
      if (!activeBubble) return;

      stopThinkingRotation();

      // Tamamlanan metinden kaynakça etiketlerini kesin olarak siler
      const finalText = aiStreamBuffer.replace(/\s*\[\s*(?:#\s*)?(?:doc_)?\d+\s*\]/gi, "");
      
      if (finalText.trim() === "") {
        activeBubble.closest(".xenon-msg")?.remove();
        addBotText("Şu anda bir yanıt üretemedim. Lütfen sorunuzu farklı bir şekilde tekrarlayın.");
      } else {
        const showCapabilityMenu = isGenericCapabilityAnswer(finalText);

        if (showCapabilityMenu) {
          activeBubble.closest(".xenon-msg")?.remove();
        } else {
          let formattedText = finalText.replace(/\n/g, "<br>");
          activeBubble.innerHTML = replaceLinksWithButton(formattedText);
        }

        if (showCapabilityMenu) {
          printCapabilityMenu();
        } else {
          askFeedback("Bu yanıtımdan memnun kaldınız mı?");
        }
      }

      activeBubble = null;
      aiStreamBuffer = "";
      saveState();

      if (chatInputArea) chatInputArea.style.display = "none";
      if (chatInput) {
        chatInput.disabled = false;
        chatInput.placeholder = "Ürünle ilgili bir sorununuz mu var? Yazın...";
      }
      if (chatSendBtn) {
        chatSendBtn.disabled = false;
      }
    });

    const handleError = function (payload) {
      if (!activeBubble) return;

      stopThinkingRotation();
      aiStreamBuffer = "";
      
      const msg = (payload && payload.message) ? payload.message : "Şu anda sunucuya bağlanamıyorum. Lütfen daha sonra tekrar deneyin.";
      
      const loadingEl = activeBubble.querySelector(".xenon-typing-indicator");
      if (loadingEl) loadingEl.closest(".xenon-msg")?.remove();
      else activeBubble.closest(".xenon-msg")?.remove();
      
      activeBubble = null;

      if (chatInput) {
        chatInput.disabled = false;
        chatInput.placeholder = "Ürünle ilgili bir sorununuz mu var? Yazın...";
      }
      if (chatSendBtn) {
        chatSendBtn.disabled = false;
      }

      addBotText(msg);
      
      canAskAi = false;
      if (chatInputArea) chatInputArea.style.display = "none";
      askFeedback("Bu yanıtımdan memnun kaldınız mı?");
    };

    chatSocket.on("chat_error", handleError);
    chatSocket.on("chat:error", handleError);

    return chatSocket;
  }

  const toggleBtn = document.getElementById("xenon-chat-toggle");
  const chatContainer = document.getElementById("xenon-chat-container");
  const optionsBtn = document.getElementById("xenon-chat-options-btn");
  const dropdown = document.getElementById("xenon-chat-dropdown");
  const closeBtn = document.getElementById("btn-close-chat");
  const resetBtn = document.getElementById("btn-reset-chat");
  const minimizeBtn = document.getElementById("xenon-chat-minimize-btn");
  const resizeBtn = document.getElementById("xenon-chat-resize-btn");

  const chatInputArea = document.getElementById("xenon-chat-input-area");
  const chatInput = document.getElementById("xenon-chat-input");
  const chatSendBtn = document.getElementById("xenon-chat-send");

  if (!chatContainer) return;

  const messagesContainer = document.getElementById("xenon-messages");
  const mainMenu = document.getElementById("xenon-main-menu");
  const iframeContainer = document.getElementById("xenon-iframe-container");
  const aiIframe = document.getElementById("xenon-ai-iframe");
  const customer = window.xenonCustomer || {
    isLoggedIn: false,
    name: "Misafir",
  };
  
  const HISTORY_KEY = "xenon_menu_history_v4";

  const ICONS = {
    link_order_shipping:
      '<svg viewBox="0 0 24 24" fill="none"><path d="M4 8.5 12 4l8 4.5v7L12 20l-8-4.5v-7Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M12 12v8M12 12 4 8.5M12 12l8-3.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    link_return_exchange:
      '<svg viewBox="0 0 24 24" fill="none"><path d="M7 8H4V5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 8a8 8 0 0 1 13.5-5.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M17 16h3v3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 16a8 8 0 0 1-13.5 5.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    link_fault_repair:
      '<svg viewBox="0 0 24 24" fill="none"><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L4 17l3 3 5.3-5.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.5-2.5 2.5-2.5Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>',
    link_payment_invoice:
      '<svg viewBox="0 0 24 24" fill="none"><rect x="3.5" y="6" width="17" height="12" rx="2.5" stroke="currentColor" stroke-width="1.7"/><path d="M3.5 10h17M7 14h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    campaigns:
      '<svg viewBox="0 0 24 24" fill="none"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" stroke="currentColor" stroke-width="1.7"/></svg>',
    ai_support:
      '<svg viewBox="0 0 24 24" fill="none"><path d="M12 3.5 13.6 8 18 9.6 13.6 11.2 12 15.7 10.4 11.2 6 9.6 10.4 8 12 3.5Z" fill="currentColor"/><path d="M18.5 14.5 19.2 16.3 21 17l-1.8.7-.7 1.8-.7-1.8L16 17l1.8-.7.7-1.8Z" fill="currentColor"/></svg>',
    feedback_yes: "🙂",
    feedback_no: "😕",
    show_main_menu: "",
  };

  const BOT_AVATAR = `<div class="xenon-bot-avatar" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M12 3.5 13.8 8.2 18.5 10 13.8 11.8 12 16.5 10.2 11.8 5.5 10 10.2 8.2 12 3.5Z" fill="currentColor"/></svg></div>`;

  const mainMenuButtons = [
    { label: "Sipariş & Teslimat", step: "link_order_shipping" },
    { label: "İade", step: "link_return_exchange" },
    { label: "Teknik Servis", step: "link_fault_repair" },
    { label: "Ödeme / Fatura", step: "link_payment_invoice" },
    { label: "Kampanyalar", step: "campaigns" },
    { label: "Ürün Asistanı", step: "ai_support" },
  ];

  const REDIRECT_TOPICS = [
    {
      step: "link_order_shipping",
      phrase: "sipariş/teslimat",
      keywords: [
        "kargo",
        "siparis",
        "teslimat",
        "teslim edil",
        "gonderi",
        "kurye",
        "takip numarasi",
        "takip no",
        "ne zaman gelir",
        "ne zaman ulasir",
        "kac gunde gelir",
        "kac gunde ulasir",
      ],
    },
    {
      step: "link_return_exchange",
      phrase: "iade",
      keywords: [
        "iade",
        "iade kargo",
        "iade etmek",
        "degisim",
        "degistirmek istiyorum",
        "urun degistir",
        "geri gonder",
        "cayma hakki",
      ],
    },
    {
      step: "link_fault_repair",
      phrase: "arıza/teknik servis",
      keywords: [
        "ariza",
        "tamir",
        "bozul",
        "bozuk",
        "calismiyor",
        "acilmiyor",
        "sarj olmuyor",
        "teknik servis",
        "servise gonder",
        "garanti",
      ],
    },
    {
      step: "link_payment_invoice",
      phrase: "ödeme/fatura",
      keywords: [
        "fatura",
        "odeme",
        "para iade",
        "tahsilat",
        "kredi karti",
        "taksit",
        "havale",
        "iban",
      ],
    },
  ];

  function normalizeTr(text) {
    return (text || "")
      .toLocaleLowerCase("tr")
      .replace(/[ıîi̇]/g, "i")
      .replace(/ş/g, "s")
      .replace(/ğ/g, "g")
      .replace(/[üû]/g, "u")
      .replace(/ö/g, "o")
      .replace(/ç/g, "c")
      .replace(/â/g, "a");
  }

  function redirectTopicFor(question) {
    const normalized = normalizeTr(question);

    let best = null;
    let bestLen = 0;
    for (const topic of REDIRECT_TOPICS) {
      for (const kw of topic.keywords) {
        if (kw.length > bestLen && normalized.includes(kw)) {
          best = topic;
          bestLen = kw.length;
        }
      }
    }
    if (!best) return null;

    const button = mainMenuButtons.find((b) => b.step === best.step);
    return button ? { button: button, phrase: best.phrase } : null;
  }

  function printRedirect(topic) {
    canAskAi = false;
    if (chatInputArea) chatInputArea.style.display = "none";
    addBotText(
      "Bu soru " +
        topic.phrase +
        " ile ilgili görünüyor. Sizi ilgili menüye yönlendireyim:"
    );
    addBotButtons([topic.button]);
    askFeedback("Size yardımcı olabildik mi?");
  }

  const GENERIC_CAPABILITY_ANSWER =
    "Ürünlerimizle ilgili size bilgi verebilir ve diğer tüm sorularınızda destek olabilirim.";

  function isGenericCapabilityAnswer(text) {
    const strip = (s) =>
      normalizeTr(s)
        .replace(/[.,;:!?…]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    return strip(text) === strip(GENERIC_CAPABILITY_ANSWER);
  }

  function printCapabilityMenu() {
    canAskAi = false;
    if (chatInputArea) chatInputArea.style.display = "none";
    addBotText(
      "Ürünlerimizle ilgili bilgi verebilir; sipariş, iade, teknik servis ve ödeme konularında sizi doğru adrese yönlendirebilirim. Aşağıdan konu seçerek başlayabiliriz."
    );
    addBotButtons(mainMenuButtons.filter((b) => b.step !== "ai_support"));
  }

  let activeChatTimers = [];
  let feedbackTimer = null;
  let isFeedbackPending = false;

  function clearFeedbackTimer() {
    if (feedbackTimer) {
      clearTimeout(feedbackTimer);
      feedbackTimer = null;
    }
    isFeedbackPending = false;
  }

  function safeTimeout(callback, delay) {
    const timer = setTimeout(callback, delay);
    activeChatTimers.push(timer);
    return timer;
  }

  function handlePageLeave() {
    activeChatTimers.forEach(clearTimeout);
    if (isFeedbackPending) {
      appendFeedbackQuestion();
      isFeedbackPending = false;
    }
  }

  window.addEventListener("beforeunload", handlePageLeave);
  window.addEventListener("pagehide", handlePageLeave);

  const lastLoginState = localStorage.getItem("xenon_last_login_state");
  const currentLoginState = customer.isLoggedIn.toString();

  if (lastLoginState !== null && lastLoginState !== currentLoginState) {
    localStorage.removeItem(HISTORY_KEY);
    localStorage.removeItem("xenon_menu_history");
    localStorage.setItem("xenon_active_screen", "menu");
    if (messagesContainer) messagesContainer.innerHTML = "";
    if (aiIframe && aiIframe.contentWindow) {
      aiIframe.contentWindow.postMessage({ action: "RESET_CHAT" }, "*");
    }
  }
  localStorage.setItem("xenon_last_login_state", currentLoginState);

  const activeScreen = localStorage.getItem("xenon_active_screen") || "menu";

  if (activeScreen === "ai" && chatInputArea) {
    canAskAi = true;
    chatInputArea.style.display = "flex";
  }

  function saveState() {
    if (messagesContainer) {
      localStorage.setItem(HISTORY_KEY, messagesContainer.innerHTML);
    }
  }

  function getTimestamp() {
    const now = new Date();
    return `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
  }

  function hideLastBotTime() {
    if (
      messagesContainer.lastElementChild &&
      messagesContainer.lastElementChild.getAttribute("data-sender") === "bot"
    ) {
      const oldTime =
        messagesContainer.lastElementChild.querySelector(".xenon-time");
      if (oldTime) oldTime.remove();
    }
  }

  function addMessage(text) {
    if (!messagesContainer) return;

    const wrapper = document.createElement("div");
    wrapper.className = "xenon-msg xenon-msg--user";
    wrapper.setAttribute("data-sender", "user");

    const bubble = document.createElement("div");
    bubble.className = "xenon-bubble xenon-bubble--user";
    bubble.textContent = text;

    const timeDiv = document.createElement("div");
    timeDiv.className = "xenon-time xenon-time--user";
    timeDiv.textContent = getTimestamp();

    wrapper.appendChild(bubble);
    wrapper.appendChild(timeDiv);
    messagesContainer.appendChild(wrapper);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
    saveState();
  }

  function addBotText(htmlContent) {
    if (!messagesContainer) return;
    hideLastBotTime();

    const wrapper = document.createElement("div");
    wrapper.className = "xenon-msg xenon-msg--bot";
    wrapper.setAttribute("data-sender", "bot");

    const row = document.createElement("div");
    row.className = "xenon-msg__row";
    row.innerHTML = BOT_AVATAR;

    const bubble = document.createElement("div");
    bubble.className = "xenon-bubble xenon-bubble--bot";
    bubble.innerHTML = htmlContent;
    row.appendChild(bubble);

    const timeDiv = document.createElement("div");
    timeDiv.className = "xenon-time";
    timeDiv.textContent = getTimestamp();

    wrapper.appendChild(row);
    wrapper.appendChild(timeDiv);
    messagesContainer.appendChild(wrapper);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
    saveState();
  }

  function getButtonVariant(step, buttonsArray) {
    if (step === "show_main_menu") return "ghost";
    if (step.startsWith("feedback_")) return "pill";
    const cardSteps = ["link_order_shipping", "link_return_exchange", "link_fault_repair", "link_payment_invoice", "campaigns", "ai_support"];
    if (cardSteps.includes(step)) return "card";
    return "pill";
  }

  function renderButton(btn, variant, spanFull) {
    const icon = ICONS[btn.step] || "";
    const spanClass = spanFull ? " xenon-flow-btn--span" : "";

    if (variant === "card") {
      return `<button class="xenon-flow-btn xenon-flow-btn--card${spanClass}" data-step="${btn.step}" data-label="${btn.label}" type="button">
                <span class="xenon-flow-btn__icon">${icon}</span>
                <span class="xenon-flow-btn__label">${btn.label}</span>
            </button>`;
    }

    if (variant === "ghost") {
      return `<button class="xenon-flow-btn xenon-flow-btn--ghost" data-step="${btn.step}" data-label="${btn.label}" type="button">${btn.label}</button>`;
    }

    const emoji =
      typeof icon === "string" && !icon.includes("<svg") ? icon : "";
    return `<button class="xenon-flow-btn xenon-flow-btn--pill" data-step="${
      btn.step
    }" data-label="${btn.label}" type="button">${emoji ? emoji + " " : ""}${btn.label}</button>`;
  }

  function addBotButtons(buttonsArray) {
    if (!messagesContainer || !buttonsArray || buttonsArray.length === 0)
      return;
    hideLastBotTime();

    const variant = getButtonVariant(buttonsArray[0].step, buttonsArray);
    const layoutClass =
      variant === "card"
        ? "xenon-actions--menu"
        : variant === "pill"
        ? "xenon-actions--feedback"
        : "xenon-actions--stack";

    const wrapper = document.createElement("div");
    wrapper.className = "xenon-msg xenon-msg--bot";
    wrapper.setAttribute("data-sender", "bot");

    const actions = document.createElement("div");
    actions.className = `xenon-actions ${layoutClass}`;

    const cardCount = buttonsArray.filter(
      (b) => getButtonVariant(b.step, buttonsArray) === "card"
    ).length;
    buttonsArray.forEach((btn, index) => {
      const btnVariant = getButtonVariant(btn.step, buttonsArray);
      const spanFull =
        btnVariant === "card" &&
        cardCount % 2 === 1 &&
        index === buttonsArray.length - 1;
      actions.insertAdjacentHTML(
        "beforeend",
        renderButton(btn, btnVariant, spanFull)
      );
    });

    const timeDiv = document.createElement("div");
    timeDiv.className = "xenon-time";
    timeDiv.textContent = getTimestamp();

    wrapper.appendChild(actions);
    wrapper.appendChild(timeDiv);
    messagesContainer.appendChild(wrapper);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
    saveState();
  }

  function showLoggedInMenu(msg) {
    canAskAi = false;
    if (chatInputArea) chatInputArea.style.display = "none";
    localStorage.setItem("xenon_active_screen", "menu");

    if (msg) addBotText(msg);
    else addBotText("Size nasıl yardımcı olabilirim?");
    addBotButtons(mainMenuButtons);
  }

  function appendFeedbackQuestion(customQuestionText) {
    const questionText = customQuestionText || "Bu yanıtımdan memnun kaldınız mı?";
    const botBubbles = document.querySelectorAll(".xenon-bubble--bot");
    
    if (botBubbles.length > 0) {
      const lastBubble = botBubbles[botBubbles.length - 1];
      if (
        lastBubble &&
        (lastBubble.textContent.includes("Bu yanıtımdan memnun kaldınız mı?") || 
         lastBubble.textContent.includes("Size yardımcı olabildik mi?"))
      ) {
        return; 
      }
    }

    if (document.getElementById("xenon-messages")) {
      addBotText(questionText);
      addBotButtons([
        { label: "Evet", step: "feedback_yes" },
        { label: "Hayır", step: "feedback_no" },
        { label: "Ana Menü", step: "show_main_menu" },
      ]);
    }
  }

  function askFeedback(customQuestionText) {
    clearFeedbackTimer();
    isFeedbackPending = true; 

    feedbackTimer = setTimeout(() => {
      if (isFeedbackPending) {
        appendFeedbackQuestion(customQuestionText);
        isFeedbackPending = false; 
      }
    }, 4000);
  }

  function loadFlow() {
    const saved = localStorage.getItem(HISTORY_KEY);

    if (saved && saved.trim() !== "") {
      messagesContainer.innerHTML = saved;
      messagesContainer.scrollTop = messagesContainer.scrollHeight;

      const lastMsg = messagesContainer.lastElementChild;
      if (lastMsg && lastMsg.getAttribute("data-sender") === "bot") {
        if (lastMsg.querySelector(".xenon-actions, .xenon-flow-btn")) {
          if (chatInputArea) {
            chatInputArea.style.display = "none";
          }
        }

        const text = lastMsg.textContent || "";
        if (!text.includes("Bu yanıtımdan memnun kaldınız mı?") && 
            !text.includes("Size yardımcı olabildik mi?") && 
            !lastMsg.querySelector(".xenon-actions")) {
          safeTimeout(() => {
            appendFeedbackQuestion("Bu yanıtımdan memnun kaldınız mı?");
          }, 1000);
        }
      }
    } else {
      const greetingName =
        customer.isLoggedIn && customer.name !== "Misafir"
          ? customer.name + ", "
          : "";
      const welcomeMessage = `Merhaba ${greetingName}Xenon Smart'a hoş geldiniz 👋<br><br>Size destek olmaktan mutluluk duyarım. İhtiyacınıza uygun konuyu aşağıdan seçerek hemen başlayabiliriz.<br><br><a href="https://shop.xenonsmart.com/pages/gizlilik-ve-guvenlik">Xenon Smart Gizlilik Politikası</a>`;

      addBotText(welcomeMessage);
      addBotButtons(mainMenuButtons);
    }

    if (chatInput) {
      chatInput.disabled = false;
      chatInput.placeholder = "Ürünle ilgili bir sorununuz mu var? Yazın...";
    }
    if (chatSendBtn) {
      chatSendBtn.disabled = false;
    }
  }

  function handleUserApiQuestion() {
    if (!chatInput) return;
    const question = chatInput.value.trim();
    if (!question) return;

    clearFeedbackTimer();
    addMessage(question);
    chatInput.value = "";

    if (chatInputArea) chatInputArea.style.display = "none";

    const redirectTopic = redirectTopicFor(question);
    if (redirectTopic) {
      printRedirect(redirectTopic);
      return;
    }

    askWsQuestion(question);
  }

  function askWsQuestion(question) {
    if (chatInput) {
      chatInput.disabled = true;
      chatInput.placeholder = "Asistan yanıtlıyor, lütfen bekleyin...";
    }
    if (chatSendBtn) {
      chatSendBtn.disabled = true;
    }

    if (activeBubble) {
      stopThinkingRotation();

      // Eski mesajı toparlarken de kaynakça temizliği yapılır
      let finalBuffer = aiStreamBuffer
        .replace(/\s*\[\s*(?:#\s*)?(?:doc_)?\d+\s*\]/gi, "")
        .replace(/\s*\[[^\]]*$/, "");
        
      activeBubble.innerHTML = replaceLinksWithButton(finalBuffer.replace(/\n/g, "<br>"));
      activeBubble = null;
    }
    aiStreamBuffer = "";

    const requestId = "req-" + Date.now() + "-" + Math.random().toString(36).slice(2, 7);
    const socket = getSocket();

    function emitQuestion() {
      hideLastBotTime();

      const wrapper = document.createElement("div");
      wrapper.className = "xenon-msg xenon-msg--bot";
      wrapper.setAttribute("data-sender", "bot");

      const row = document.createElement("div");
      row.className = "xenon-msg__row";
      row.innerHTML = BOT_AVATAR;

      const bubble = document.createElement("div");
      bubble.className = "xenon-bubble xenon-bubble--bot";

      let msgIndex = Math.floor(Math.random() * XENON_THINKING_MESSAGES.length);

      bubble.innerHTML = `
        <div class="xenon-typing-indicator" id="xenon-loading-${requestId}">
          <svg class="xenon-spinner-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" style="opacity: 0.25;"></circle>
            <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="xenon-thinking-text"></span>
        </div>
      `;
      const textEl = bubble.querySelector(".xenon-thinking-text");
      textEl.textContent = XENON_THINKING_MESSAGES[msgIndex];

      row.appendChild(bubble);

      const timeDiv = document.createElement("div");
      timeDiv.className = "xenon-time";
      timeDiv.textContent = getTimestamp();

      wrapper.appendChild(row);
      wrapper.appendChild(timeDiv);
      messagesContainer.appendChild(wrapper);
      messagesContainer.scrollTop = messagesContainer.scrollHeight;

      activeBubble = bubble;
      aiStreamBuffer = "";

      stopThinkingRotation();
      thinkingTimer = setInterval(function () {
        const liveText = document.querySelector(
          "#xenon-loading-" + requestId + " .xenon-thinking-text"
        );
        if (!liveText) {
          stopThinkingRotation();
          return;
        }
        liveText.classList.add("xenon-thinking-text--fading");
        thinkingFadeTimer = setTimeout(function () {
          thinkingFadeTimer = null;
          if (!liveText.isConnected) return;
          msgIndex = (msgIndex + 1) % XENON_THINKING_MESSAGES.length;
          liveText.textContent = XENON_THINKING_MESSAGES[msgIndex];
          liveText.classList.remove("xenon-thinking-text--fading");
        }, XENON_THINKING_FADE_MS);
      }, XENON_THINKING_ROTATE_MS);

      // Session ID ve Müşteri bilgisi payload'a dahil edilip gönderiliyor
      socket.emit("chat:question", { 
        sessionId: getOrCreateSessionId(),
        customer: window.xenonCustomer || { isLoggedIn: false, name: "Misafir", email: "Misafir" },
        question: question, 
        requestId: requestId, 
        top_k: 5 
      });

      if (responseTimeoutTimer) clearTimeout(responseTimeoutTimer);
      responseTimeoutTimer = setTimeout(function () {
        if (activeBubble) {
          stopThinkingRotation();

          const loadingEl = activeBubble.querySelector(".xenon-typing-indicator");
          if (loadingEl) loadingEl.closest(".xenon-msg")?.remove();
          else activeBubble.closest(".xenon-msg")?.remove();

          addBotText("Bağlantı zaman aşımına uğradı! Lütfen sorunuzu tekrarlayın.");

          activeBubble = null;
          aiStreamBuffer = "";

          canAskAi = false;
          if (chatInputArea) chatInputArea.style.display = "none";

          if (chatInput) {
            chatInput.disabled = false;
            chatInput.placeholder = "Ürünle ilgili bir sorununuz mu var? Yazın...";
          }
          if (chatSendBtn) {
            chatSendBtn.disabled = false;
          }

          askFeedback("Bu yanıtımdan memnun kaldınız mı?");
        }
      }, 60000);
    }

    if (socket.connected) {
      emitQuestion();
    } else {
      socket.once("connect", emitQuestion);
      socket.once("connect_error", function () {
        stopThinkingRotation();
        activeBubble = null;
        aiStreamBuffer = "";

        if (chatInput) {
          chatInput.disabled = false;
          chatInput.placeholder = "Ürünle ilgili bir sorununuz mu var? Yazın...";
        }
        if (chatSendBtn) {
          chatSendBtn.disabled = false;
        }

        const loadingEl = document.querySelector(".xenon-typing-indicator");
        if (loadingEl) loadingEl.closest(".xenon-msg")?.remove();
        addBotText("Şu anda sunucuya bağlanamıyorum. Lütfen daha sonra tekrar deneyin.");
        
        canAskAi = false;
        if (chatInputArea) chatInputArea.style.display = "none";
        askFeedback("Bu yanıtımdan memnun kaldınız mı?");
      });
    }
  }

  if (chatInput && chatSendBtn) {
    chatInput.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        handleUserApiQuestion();
      }
    });
    chatSendBtn.addEventListener("click", handleUserApiQuestion);
  }

  loadFlow();

  function toggleChat() {
    if (
      chatContainer.style.display === "none" ||
      chatContainer.style.display === ""
    ) {
      chatContainer.style.display = "flex";
      toggleBtn.style.display = "none";
      localStorage.setItem("xenon_chat_open", "true");

      if (messagesContainer && messagesContainer.childElementCount === 0)
        loadFlow();

      safeTimeout(() => {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      }, 50);
    } else {
      chatContainer.style.display = "none";
      toggleBtn.style.display = "flex";
      dropdown.style.display = "none";
      localStorage.setItem("xenon_chat_open", "false");

      if (localStorage.getItem("xenon_active_screen") === "ai") {
        localStorage.setItem("xenon_active_screen", "menu");
        canAskAi = false;
        if (chatInputArea) chatInputArea.style.display = "none";
        showLoggedInMenu(
          "Sohbeti arka plana aldınız. Başka bir işlem yapmak ister misiniz?"
        );
      }
    }
  }

  if (toggleBtn) toggleBtn.addEventListener("click", toggleChat);
  if (closeBtn) closeBtn.addEventListener("click", toggleChat);

  if (minimizeBtn) {
    minimizeBtn.addEventListener("click", toggleChat);
  }

  if (resizeBtn) {
    resizeBtn.addEventListener("click", () => {
      chatContainer.classList.toggle("is-minimized");
      
      if (messagesContainer) {
        setTimeout(() => {
          messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }, 350);
      }
    });
  }

  if (optionsBtn)
    optionsBtn.addEventListener("click", () => {
      dropdown.style.display =
        dropdown.style.display === "none" || dropdown.style.display === ""
          ? "flex"
          : "none";
    });

  document.addEventListener("click", (e) => {
    if (!dropdown || dropdown.style.display === "none") return;
    const wrap = optionsBtn && optionsBtn.closest(".xenon-chat-menu-wrap");
    if (wrap && !wrap.contains(e.target)) dropdown.style.display = "none";
  });

  if (localStorage.getItem("xenon_chat_open") === "true") {
    chatContainer.style.display = "flex";
    toggleBtn.style.display = "none";
    safeTimeout(() => {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }, 50);
  }

  // --- 2. TIKLAMA VE SOCKET İLE LOGLAMA DİNLEYİCİSİ ---
  if (messagesContainer) {
    messagesContainer.addEventListener("click", function (e) {
      const ctaLink = e.target.closest(".xenon-cta");
      if (ctaLink) {
        toggleChat();
        return; 
      }

      const btn = e.target.closest(".xenon-flow-btn");
      if (!btn || !messagesContainer.contains(btn)) return;

      clearFeedbackTimer();

      const step = btn.getAttribute("data-step");
      const label = btn.getAttribute("data-label");

      // SOCKET İLE GATEWAY/PORTAL SUNUCUSUNA LOGU GÖNDERİYORUZ
      logButtonClick(step, label);

      const siblings = btn.parentNode
        ? Array.from(btn.parentNode.querySelectorAll(".xenon-flow-btn"))
        : [btn];

      siblings.forEach((b) => {
        b.disabled = true;
        b.style.opacity = "0.55";
        b.classList.remove("is-selected");
      });

      btn.style.opacity = "1";
      btn.classList.add("is-selected");

      addMessage(label);

      safeTimeout(() => {
        if (step === "link_order_shipping") {
          canAskAi = false;
          if (chatInputArea) chatInputArea.style.display = "none";
          addBotText(
            `Sipariş ve teslimat talebinizi birlikte oluşturalım.${buildCta(
              "/pages/support-request?sub_topic=ORDER_AND_SHIPPING",
              "Sipariş ve Teslimat talebi oluştur"
            )}`
          );
          askFeedback("Size yardımcı olabildik mi?");
        } else if (step === "link_return_exchange") {
          canAskAi = false;
          if (chatInputArea) chatInputArea.style.display = "none";
          addBotText(
            `Talebinizi birlikte oluşturalım, birkaç adım sürecek.${buildCta(
              "https://account.xenonsmart.com/orders",
              "İade talebi oluştur"
            )}`
          );
          askFeedback("Size yardımcı olabildik mi?");
        } else if (step === "link_fault_repair") {
          canAskAi = false;
          if (chatInputArea) chatInputArea.style.display = "none";
          addBotText(
            `Teknik servis sürecini başlatabilirsiniz.${buildCta(
              "/pages/support-request?sub_topic=FAULT_REPAIR_SERVICE",
              "Teknik Servis / Arıza bildir"
            )}`
          );
          askFeedback("Size yardımcı olabildik mi?");
        } else if (step === "link_payment_invoice") {
          canAskAi = false;
          if (chatInputArea) chatInputArea.style.display = "none";
          addBotText(
            `Ödeme ve fatura işlemleriniz için devam edin.${buildCta(
              "/pages/support-request?sub_topic=PAYMENT_AND_INVOICE",
              "Ödeme / Fatura işlemi başlat"
            )}`
          );
          askFeedback("Size yardımcı olabildik mi?");
        } else if (step === "campaigns") {
          canAskAi = false;
          if (chatInputArea) chatInputArea.style.display = "none";
          addBotText(
            `Güncel kampanyalarımızı ve fırsatlarımızı inceleyebilirsiniz.${buildCta(
              "https://shop.xenonsmart.com/collections/geceden-sabaha-firsatlar",
              "Kampanyalara Göz At"
            )}`
          );
          askFeedback("Size yardımcı olabildik mi?");
        } else if (step === "feedback_yes") {
          if (canAskAi) {
            addBotText("Harika! Yardımcı olabildiğime sevindim. Başka bir sorunuz varsa sorabilirsiniz.");
            if (chatInputArea) {
              chatInputArea.style.display = "flex";
              if (chatInput) chatInput.focus();
            }
          } else {
            showLoggedInMenu("Harika! Yardımcı olabildiğime sevindim. Başka bir konuda yardımcı olabilir miyim?");
          }
        } else if (step === "feedback_no") {
          canAskAi = false;
          if (chatInputArea) chatInputArea.style.display = "none";
          addBotText(
            `Destek ekibimizle iletişime geçmek için bir geri bildirim oluşturabilirsiniz.${buildCta(
              "https://shop.xenonsmart.com/pages/support-request?sub_topic=CUSTOMER_SERVICE",
              "Geri bildirim oluştur"
            )}`
          );
          askFeedback("Size yardımcı olabildik mi?");
        } else if (step === "show_main_menu") {
          canAskAi = false;
          showLoggedInMenu();
        } else if (step === "ai_support") {
          canAskAi = true;
          localStorage.setItem("xenon_active_screen", "ai");
          addBotText(
            "Ürünlerinizin kullanımı ve özellikleri hakkında sorularınızı yanıtlayabilirim. Sipariş ve iade işlemleri için ana menüdeki ilgili başlıkları kullanabilirsiniz."
          );
          if (chatInputArea) {
            chatInputArea.style.display = "flex";
            if (chatInput) chatInput.focus();
          }
        }
      }, 450);
    });
  }

  window.addEventListener("message", (e) => {
    if (e.data && e.data.action) {
      if (e.data.action === "END_CHAT") {
        if (iframeContainer) iframeContainer.style.display = "none";
        if (mainMenu) mainMenu.style.display = "flex";
        localStorage.setItem("xenon_active_screen", "menu");
        showLoggedInMenu(
          "Sohbet sonlandırıldı. Başka bir konuda yardımcı olabilir miyim?"
        );
      } else if (e.data.action === "TICKET_LINK") {
        if (iframeContainer) iframeContainer.style.display = "none";
        if (mainMenu) mainMenu.style.display = "flex";
        localStorage.setItem("xenon_active_screen", "menu");
        addBotText(
          `Geri bildirimiz için ilgili sayfaya yönlendiriliyorsunuz.${buildCta(
            "/pages/support-request?main_topic=COMPLAINT&sub_topic=CUSTOMER_SERVICE",
            "Geri bildirim Sayfası"
          )}`
        );

        localStorage.setItem("xenon_pending_main_menu", "true");
        safeTimeout(() => {
          if (document.getElementById("xenon-messages")) {
            showLoggedInMenu("Farklı bir işlem yapmak ister misiniz?");
          }
          localStorage.removeItem("xenon_pending_main_menu");
        }, 4000);
      }
    }
  });

  if (resetBtn) {
    resetBtn.addEventListener("click", () => {
      canAskAi = false;
      localStorage.removeItem(HISTORY_KEY);
      localStorage.removeItem("xenon_menu_history");
      localStorage.setItem("xenon_active_screen", "menu");
      if (messagesContainer) messagesContainer.innerHTML = "";
      if (chatInputArea) chatInputArea.style.display = "none";
      if (aiIframe && aiIframe.contentWindow)
        aiIframe.contentWindow.postMessage({ action: "RESET_CHAT" }, "*");
      if (iframeContainer) iframeContainer.style.display = "none";
      if (mainMenu) mainMenu.style.display = "flex";
      if (dropdown) dropdown.style.display = "none";

      stopThinkingRotation();
      activeBubble = null;
      aiStreamBuffer = "";
      if (chatInput) {
        chatInput.disabled = false;
        chatInput.placeholder = "Ürünle ilgili bir sorununuz mu var? Yazın...";
      }
      if (chatSendBtn) {
        chatSendBtn.disabled = false;
      }

      loadFlow();
    });
  }
});